import { sectionCard } from "./constants";

type ProductStatusSectionProps = {
  isActive: boolean;
  setIsActive: (active: boolean) => void;
  isFeatured: boolean;
  setIsFeatured: (featured: boolean) => void;
};

export const ProductStatusSection = ({
  isActive,
  setIsActive,
  isFeatured,
  setIsFeatured,
}: ProductStatusSectionProps) => (
  <section className={sectionCard}>
    <h2 className="text-xl font-semibold text-[#5c2f2f] mb-4">
      Product Status
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <label className="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
        <input
          type="checkbox"
          checked={isActive}
          onChange={(e) => setIsActive(e.target.checked)}
        />
        <div>
          <p className="font-medium text-gray-800">Active</p>
          <p className="text-xs text-gray-500">
            Product will be available in the store
          </p>
        </div>
      </label>

      <label className="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
        <input
          type="checkbox"
          checked={isFeatured}
          onChange={(e) => setIsFeatured(e.target.checked)}
        />
        <div>
          <p className="font-medium text-gray-800">Featured</p>
          <p className="text-xs text-gray-500">
            Show this product in featured sections
          </p>
        </div>
      </label>
    </div>
  </section>
);
